<template>
  <span>
    <span v-if="valid" class="incidence">
      <span class="incidence-value-and-mean">
        <span class="incidence-value"
          :style="qualityStyle">
          <span :class="valueClasses">
            {{ displayedValue.incidence }}
          </span>
        </span>
        <br />
        <small v-if="value.mean >= 0">({{ displayedValue.mean }})</small>
      </span>
      <span v-if="icon" class="incidence-icon">
        <span class="glyphicon" :class="`glyphicon-${icon.icon} txt-${icon.style}`" aria-hidden="true">
        </span>
      </span>
    </span>
  </span>
</template>
<script>
import results from '@/sui/data/results'

export default {
  name: 'incidence',

  props: {
    value: {
      type: Object,
      required: true
    },

    icon: {
      type: Object,
      default: null
    }
  },

  data: function () {
    return {
    }
  },

  computed: {
    valid: function () {
      const { incidence, mean, quality } = this.value
      return incidence != null &&
             mean != null &&
             quality >= 0 && quality < results.qualities.length
    },

    quality: function () {
      return results.qualities[this.value.quality]
    },

    qualityStyle: function () {
      const factor = this.value.incidence > 0 ? 1 : 0.5
      return {
        'background-color': this.quality.color,
        opacity: this.quality.opacity * factor
      }
    },

    valueClasses: function () {
      return this.valueStyle != null ? `txt-${this.valueStyle}` : ''
    },

    displayedValue: function () {
      if (!this.valid) {
        return {}
      }

      return {
        mean: this.value.mean != null ? results.fixDecimals(this.value.mean) : null,
        incidence: results.fixDecimals(this.value.incidence)
      }
    }
  }
}
</script>
<style scoped lang="less">
@import '~variables';

.incidence {
  display: flex;
  justify-content: center;
  gap: 0.2rem;

  .incidence-value {
    font-size: 110%;
    color: white;
    font-weight: bold;
    padding: 0.3rem;
    border-radius: 0.3rem;
  }

  .incidence-icon {
    font-size: 130%;
  }
}
</style>
